<template>
    <section class="np-title-section">
        <i class="pre-title">{{ preTitle }}</i>
        <h1 class="title">{{ title }}</h1>
    </section>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        preTitle: '',
        title: '',
    },
});
</script>
<style scoped>
.np-title-section {

}

.title {
    font-size: 2rem;
}

.pre-title {
    display: none;
    font-size: 1.2rem;
}
</style>
